import React from "react";
import AuthHeroColumn from "./AuthHeroColumn";

const LoginHeroColumn = (props) => <AuthHeroColumn {...props} variant="login" />;

export default LoginHeroColumn;
